import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import RemoveBackground from '../../components/RemoveBackground';

const RemoveBg: React.FC = () => (
  <ToolLayout
    title="Remove Background from Image Free Online | AllTools"
    description="Remove image backgrounds instantly with AI. Get transparent PNG. Free online background remover tool."
    canonicalPath="/remove-background"
  >
    <RemoveBackground />
  </ToolLayout>
);

export default RemoveBg;
